<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20,30, 50, 200]"
                    :page-size="pageSize" ref="table" :isAddPageToRouter="true" :isOutside="isOutside" v-loading="loading">
      <wt-table :list="tableData" :maxHeight="tableMaxHeight" ref="wtTable">
        <template slot="before">
          <el-table-column label="商品" min-width="200" header-align="center" :fit="false">
            <template slot-scope="scope">
              <div :class="$style['goods-price-name']">
                <pt-img :class="$style['banner-picture']" :src="scope.row.goods&&scope.row.goods[0]&&scope.row.goods[0].mainPicture"
                        styleName="mall-goods-banner-pictures"></pt-img>
                <div :class="$style['goods-name-price']">
                  <div> {{scope.row.goods[0].name}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="订单号/支付流水号/下单时间" min-width="180">
            <template slot-scope="scope">
              <div>订单号：{{scope.row.orderNumber}}</div>
              <div>支付流水号：{{scope.row.paymentDetails&&scope.row.paymentDetails.payNumber}}</div>
              <div>下单时间：{{scope.row.created_date}}</div>
            </template>
          </el-table-column>
          <el-table-column label="分/子公司" min-width="180">
            <template slot-scope="scope">
              <div>{{scope.row.organizationName?scope.row.organizationName:'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="单价（元）/数量" min-width="100">
            <template slot-scope="scope">
              <div>
                <div>{{scope.row.sales_price}}</div>
                <div>{{scope.row.goods_number}}件</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" min-width="130">
            <template slot-scope="scope">
              <div>姓名：{{scope.row.placeUserRoleInformation&&scope.row.placeUserRoleInformation.fullName}}</div>
              <div>手机号：{{scope.row.placeUserRoleInformation&&scope.row.placeUserRoleInformation.mobile}}</div>
            </template>
          </el-table-column>
          <el-table-column label="实付款（元）" min-width="100">
            <template slot-scope="scope">
              <div>{{scope.row.reality_price}}</div>
            </template>
          </el-table-column>
          <el-table-column v-if="isRenewDeposit" label="发送抽奖通知">
            <template slot-scope="scope">
              <div>{{scope.row.renewDepositNoLuckDrawNotice?'是':'否'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" min-width="100">
            <template slot-scope="scope">
              <div>{{scope.row.order_status}}</div>
            </template>
          </el-table-column>
          <el-table-column label="支付方式">
            <template slot-scope="scope">
              <div>{{scope.row.channelName||'--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="订单来源">
            <template slot-scope="scope">
              <div>{{scope.row.business_source}}</div>
            </template>
          </el-table-column>
          <el-table-column label="分享成单">
            <template slot-scope="scope">
              <div>{{scope.row.goodsSharingOrder?'是':"否"}}</div>
            </template>
          </el-table-column>
          <el-table-column label="分享人" min-width="110">
            <template slot-scope="scope">
              <div>{{scope.row.sharingPerson&&scope.row.sharingPerson.firstName}}</div>
              <div>{{scope.row.sharingPerson&&scope.row.sharingPerson.mobile}}</div>
            </template>
          </el-table-column>
					<el-table-column label="结算公司">
						<template slot-scope="scope">
						{{scope.row.goods[0]&&scope.row.goods[0].vendorInfo&&scope.row.goods[0].vendorInfo.balanceOrgName}}
					</template>
					</el-table-column>
					<el-table-colum label="是否续存">
						<template slot-scope="scope">
							{{ scope.row.extendInfo&&scope.row.extendInfo.renewFlg==='Y'?'是':'否' }}
						</template>
					</el-table-colum>
        </template>
        <slot />
      </wt-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-order-table'

export default {
  name: 'pt-order-table',
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table&&this.$refs.table.page
    },
    /* 是否续存订单 */
    isRenewDeposit () {
      return this.$route.name === 'renew-deposit-order'
    }
  },
  data () {
    return {
      tableMaxHeight: null
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getOrderList', page, next, size)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.tableMaxHeight = window.innerHeight - (this.$refs.wtTable&&this.$refs.wtTable.$el&&this.$refs.wtTable.$el.offsetTop?this.$refs.wtTable.$el.offsetTop:0) - 200

      // 监听窗口大小变化
      let self = this
      window.onresize = function () {
        self.tableMaxHeight = window.innerHeight - (self.$refs.wtTable&&self.$refs.wtTable.$el&&self.$refs.wtTable.$el.offsetTop?self.$refs.wtTable.$el.offsetTop:0) - 200
      }
    })
    // this.$refs.wtTable.$el.offsetTop：表格距离浏览器的高度
    // 150表示你想要调整的表格距离底部的高度
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.goods-price-name{
    display: flex
}
.goods-name-price{
    padding-left: 10px;
}
.banner-picture{
    max-width: 100px;
    max-height:100px;
    :global
    img{
        max-width: 100px;
        border-radius: 10px;
    }
}

</style>
